<template>
  <a
    href="mailto:info@picup.com.au"
    class="font-medium text-green-600 md:text-lg">
    info@picup.com.au
  </a>
</template>